module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated",
    staticStyle: {
      "animation-duration": ".5s"
    },
    attrs: {
      "id": "user-page"
    }
  }, [_c('profile', {
    attrs: {
      "username": _vm.profile.login,
      "profile": _vm.profile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "repo-list"
  }, [_c('div', {
    staticClass: "repo-list-header"
  }, [_vm._v("POPULAR REPOSITORIES")]), _vm._v(" "), _c('list-transition', _vm._l((_vm.repos.slice(0, 5)), function(repo, index) {
    return _c('repo-item', {
      key: repo.full_name,
      attrs: {
        "repo": repo,
        "data-index": index
      }
    })
  }), 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "view-all-btn",
    attrs: {
      "to": {
        name: 'USER_REPO_LIST'
      }
    }
  }, [_vm._v(" VIEW ALL REPOS ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88f39308!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserPage.vue
// module id = 466
// module chunks = 2